<template>
	<div class="container">
		<el-page-header @back="goBack" content="修改">
		</el-page-header>
		<div class="cont-body" v-loading="searchLoading">
			<div class="content">
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">标签<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b">
						<el-radio-group v-model="storeType" class="radio_warp">
							<div v-for="(item,index) in storeTypeList" :key="item.key" class="radio_itm_warp">
								<el-radio :label="item.key">{{item.value}}</el-radio>
							</div>
						</el-radio-group>
					</div>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">名称<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b" >
						<el-input placeholder="请输入名称" v-model="name" maxlength="30" />
					</div>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">地址<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b" >
						<el-input placeholder="请输入地址" v-model="addr" maxlength="50" />
					</div>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">联系方式<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b" >
						<el-input placeholder="请输入联系方式" v-model="tel" maxlength="50" />
					</div>
				</div>
				<!-- <div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">是否置顶（30天）<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b" style="text-align: right;">
						<el-switch
							v-model="tickTopOrNot"
							@change="tickTopChange"
							active-color="#13ce66"
							inactive-color="#ff4949">
						</el-switch>
					</div>
				</div> -->
				<div class="ctx-item inlinediv">
					<pickContact ref="pickContact" :queryUid="userInfo.fayanboId" :baseUrlpath="baseUrlpath" @changeConcactShow="changeConcactShow" :isShowConcact="isShowConcact" :isDetail="isDetail"></pickContact>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">内容<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b">
						<el-input type="textarea" v-model="reqNail" :autosize="{ minRows: 4}" maxlength="200" placeholder="请输入内容！" show-word-limit></el-input>
					</div>
				</div>
				<div class="ctx-item marb200">
					<div class="ctx-item-t">
						<div class="ctx-item-head">上传照片/视频<label class="bishu">*</label></div>
						<div class="ctx-item-headdesc"><label>({{finalFileList.length}}/{{limitFilesNum}})</label></div>
					</div>
					<div class="ctx-item-b">
						<uploadFile :baseUrlpath="baseUrlpath" :fileList="fileList" @addOrMulitiFileList="addOrMulitiFileList"></uploadFile>
					</div>
				</div>
				<!-- <div class="ctx-item">
					<div class="ctx-item-b">
						<div class="pub_jd_cost">
							<div class="jd_total">
								<label class="unit">共需花费</label>
								<label class="num">{{pubTotalCost}}</label>
								<label class="unit">金豆</label>
							</div>
							<div class="cost_desc">
								<label>发布</label>
								<label class="num">{{pubNeedCost}}</label>
								<label>金豆</label>
								<template v-if="tickTopOrNot">
									<label>+</label>
									<label>置顶</label>
									<label class="num">{{tickTopNeedCost}}</label>
									<label>金豆</label>
								</template>
							</div>
						</div>
					</div>
				</div> -->
				<div class="btn-foot">
					<div class="btn" @click="publish()">修改</div>
				</div>
			</div>	
		</div>
	</div>
</template>

<script>
	import {mapGetters,mapActions} from 'vuex'
	import uploadFile from '@/components/upload/uploadFile.vue'
	import pickContact from '@/components/pickContact.vue'
	import {queryUrl,doPost,commitFileUrl,queryUrlWithUInfo} from '@/api/index';
	import { Toast } from 'mint-ui';
	export default {
		components:{
		  uploadFile,pickContact
		},
		data(){
			return {
				reqType:'',
				multiArray:[],
				array:[],
				citysList:[],
				cascaderprops:{
					value:'id',
					label:'name',
					children:'child'
				},
				name: '',
				addr: '',
				tel: '',
				addrlatitude:'',
				addrlongitude:'',
				storeType:'0',
				reqNail:'',
				fileList:[],
				finalFileList:[],
				limitFilesNum:9,
				baseUrlpath:'',
				delicacyTags:[],
				restaurantName:'',
				reqNo:'',
				isShowConcact:false,
				tickTopOrNot:false,
				tickTopNeedCost:0,
				pubNeedCost:0,
				pubTotalCost:0,
				isDetail:false,
				searchLoading:false,
				sdr_userId:''
			}
		},
		created() {
			// console.log(this.$route.query)
			this.reqNo = this.$route.query.reqNo;
			this.citysList = this.$util.citysList;
			this.storeTypeList = this.$util.storeTypeList;
			this.queryTickJdCost()
			this.queryPubJdCost()
			this.getReqInfo()
		},
		computed: {
			...mapGetters(['userInfo'])
		},
		watch:{
			tickTopNeedCost:{
				handler(val, oldval) {
					if(this.tickTopOrNot){
						this.pubTotalCost = parseInt(val) + parseInt(this.pubNeedCost) 
					}else{
						this.pubTotalCost = parseInt(this.pubNeedCost)
					}
				}
			},
			pubNeedCost:{
				handler(val, oldval) {
					if(this.tickTopOrNot){
						this.pubTotalCost = parseInt(val) + parseInt(this.tickTopNeedCost) 
					}else{
						this.pubTotalCost = parseInt(val)
					}
				}
			},
			tickTopOrNot:{
				handler(val, oldval) {
					console.log(val)
					if(val){
						this.pubTotalCost = parseInt(this.pubNeedCost) + parseInt(this.tickTopNeedCost) 
					}else{
						this.pubTotalCost = parseInt(this.pubNeedCost)
					}
				}
			}
		},
		methods:{
			async getReqInfo(){
				this.searchLoading = true
				const initres = await queryUrlWithUInfo('/apis/getStoreRecommenDetail',{reqId:this.reqNo});
				if(initres.ec == '0'){
					this.storeType = initres.ssr_srType;
					this.name = initres.ssr_name;
					this.addr = initres.ssr_addr;
					this.tel = initres.ssr_tel;
					this.addrlatitude = initres.ssr_addrlatitude;
					this.addrlongitude = initres.ssr_addrlongitude;
					this.reqNail = initres.ssr_reqNail;
					this.isShowConcact = initres.srr_isShowConcact == '1' ? true :false;
					this.fileList = [];
					this.finalFileList = [];
					var attachlist = initres.attachlist;
					for(var index in attachlist){
						this.finalFileList.push({fileId:attachlist[index].sdra_fileid,path:attachlist[index].sdra_filePath,url:attachlist[index].sdra_filePath});
					}
					this.fileList = JSON.parse(JSON.stringify(this.finalFileList))
					this.searchLoading = false
				}
			},
			tickTopChange(e){
				var needCost = this.tickTopNeedCost;
				var _this = this;
				console.log(e)
				if(e){
					this.$confirm('置顶需花费'+needCost+'金豆'+', 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						
					}).catch(() => {
						_this.tickTopOrNot = false       
					});
				}
			},
			async queryTickJdCost(){
				const initres = await queryUrlWithUInfo('/apis/queryJdNeedCost',{queryType:'10'});
				if(initres.ec == '0'){
					this.tickTopNeedCost = parseInt( initres.jdCost)
				}
			},
			async queryPubJdCost(){
				const initres = await queryUrlWithUInfo('/apis/pubJdNeedCost',{queryType:'18'});
				if(initres.ec == '0'){
					this.pubNeedCost = parseInt(initres.jdCost)
				}
			},
			changeConcactShow(val){
				this.isShowConcact = val
			},
			goBack() {
				this.$util.goBack();
			},
			async publish(){
				var vm = this;
				
				if(this.name.length == 0){
					this.$util.msg('请输入名称');
					return false;
				}
				if(this.addr.length == 0){
					this.$util.msg('请输入地址');
					return false;
				}
				if(this.tel.length == 0){
					this.$util.msg('请输入联系方式');
					return false;
				}
				if(this.reqNail.length == 0){
					this.$util.msg('请输入内容');
					return false;
				}				
				if(this.finalFileList.length == 0){
					this.$util.msg('请上传图片');
					return false;
				}
				vm.$util.showMyLoading('加载中');
				var params = {};
				params.reqNo = this.reqNo;
				params.reqNail = this.$util.textFormat(this.reqNail);
				params.name = this.name;
				params.addr = this.addr;
				params.tel = this.tel;
				params.addrlatitude = this.addrlatitude;
				params.addrlongitude = this.addrlongitude;
				params.fileList = JSON.stringify(this.finalFileList);
				params.storeType = this.storeType;
				params.isShowConcact = this.isShowConcact ? '1' : '0';
				const initres = await queryUrlWithUInfo('/apis/modifyStoreRecommen',params);
				if(initres.ec == '0'){
					vm.$util.hideMyLoading();
					this.$util.msg("修改成功",{},()=>{
						vm.$util.goBack();
					});
				}
			},
			goChooseClassfiy(){
				this.$router.push({
				  name: 'publishIndex',
				  query: {}
				});
			},
			handleCityChange(e){
				// console.log(e)
				this.queryCurrencySymbol();
			},
			async queryCurrencySymbol(){
				const initres = await queryUrlWithUInfo('/apis/queryCurrencySymbol',{'dqModel':JSON.stringify(this.areaId)});
				if(initres.ec == '0'){
					this.CurrencySymbol = initres.currencySymbol;
				}
			},
			addOrMulitiFileList(params){
				// console.log(params)
				if(params.type == '1'){
					this.finalFileList.push({fileId:params.file.fileId,path:params.file.path,url:params.file.path,thumbPath:params.file.thumbPath})
					// console.log(this.fileList)
				}else if(params.type == '2'){
					this.finalFileList = this.finalFileList.filter((item,index) => {
						return item.fileId != params.file.fileId
					});
					// console.log(this.fileList)
				}
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.radio_warp {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		.radio_itm_warp {
			margin: 0px 10px 10px 0px;
		}
	}
	.container {
		width: 90%;
		margin: 0 auto;
		box-shadow: 0px 4px 16px 1px rgb(0 0 0 / 6%);
		height: 100%;
		padding: 10px 20px;
		.headwarp {
			.head-item {
				width: 30%;
				text-align: left;
				line-height: 50px;
				border-bottom: 2px solid #F1F1F1;
			}
			.active {
				border-bottom: 2px solid #C88854;
			}
		}
		.cont-body {
			margin-top: 20px;
			//overflow: scroll;
			min-height: calc(100% - 100px);
			.content {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				.ctx-item {
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 10px 0;
					width: 600px;
					.bishu {
						color: #FF0000;
						margin-left: 4px;
					}
					.ctx-item-t {
						margin-right: 10px;
						.ctx-item-head {
							line-height: 40px;
							width: 160px;
							text-align: left;
							font-size: 14px;
							font-weight: 700;
						}
						.ctx-item-headdesc {
							font-size: 12px;
							text-align: left;
						}
					}
					.ctx-item-b {
						flex: 1;
						text-align:left;
						.hxs-warp {
							width: 100px !important;
							margin-right: 10px;
						}
						
					}
				}
			}
			.btn-foot {
				margin-top: 10px;
				.btn {
					width: 100px;
					margin: 0 auto;
					background-color: #c88854;
					color: #fff;
					padding: 10px 20px;
					border-radius: 30px;
					cursor: pointer;
				}
			}
		}
	}
</style>
